import {ReactNode} from "react";

import {getPlanner3dData, Planner3DTypes} from "../../../constants/get_planner_3d_data";
import {IMakeablePlansOffer} from "../../types/IMakeablePlansOffer";
import {useGetPlannerInvestmentDataQuery} from "../api/fetch_investment_planner_details";
import {YslabProperty} from "./api/yslab_investments_api";
import {Planner3DImakeable} from "./Planner3DImakeable";
import {YslabPlanner3d} from "./Planner3DYslab";

interface Props {
    className?: string;
    children: ReactNode;
    vendorId?: number;
    // routedModalId has to be unique across entire view
    routedModalId: string;
    offer: IMakeablePlansOffer;
    apartmentNumber?: string;
    yslabProperty?: YslabProperty | null;
    initialBuildingUuid?: string | null;
    initialFloor?: number | null;
}

export const Planner3dModal = (props: Props) => {
    const plannerData = getPlanner3dData(props.offer.id);

    const {data: investmentData} = useGetPlannerInvestmentDataQuery({investmentUuid: props.offer.uuid});

    // For YSLAB we have a hardcoded list of offers that has YSLAB planner
    if (props.vendorId && plannerData && [Planner3DTypes.YSLAB, Planner3DTypes.YSLAB_ALLINONE].includes(plannerData.type)) {
        return (
            <YslabPlanner3d
                modalId={props.routedModalId}
                offerId={props.offer.id}
                vendorId={props.vendorId}
                offerName={props.offer.name}
                yslabProperty={props.yslabProperty}
                className={props.className}
            >
                {props.children}
            </YslabPlanner3d>
        );
    }

    // For non-YSLAB offers we want to use our own floor plans from planner 2d, but first we need to check if the offer has svg plans drawn, which means:
    // - investment is_ready === true (which means that all estates in investment are marked as ready in P2D)
    // - show_floors_navigator === true (which means that this checkbox in PH is selected)
    if (investmentData?.is_ready && props.offer.configuration.show_floors_navigator) {
        return (
            <Planner3DImakeable
                offer={props.offer}
                modalId={props.routedModalId}
                initialBuildingUuid={props.initialBuildingUuid}
                initialFloor={props.initialFloor}
                className={props.className}
            >
                {props.children}
            </Planner3DImakeable>
        );
    }

    return null;
};
import {ReactNode} from "react";

import {getPlanner3dData, Planner3DTypes} from "../../../constants/get_planner_3d_data";
import {IMakeablePlansOffer} from "../../types/IMakeablePlansOffer";
import {useGetPlannerInvestmentDataQuery} from "../api/fetch_investment_planner_details";
import {YslabProperty} from "./api/yslab_investments_api";
import {Planner3DImakeable} from "./Planner3DImakeable";
import {YslabPlanner3d} from "./Planner3DYslab";

interface Props {
    className?: string;
    children: ReactNode;
    vendorId?: number;
    // routedModalId has to be unique across entire view
    routedModalId: string;
    offer: IMakeablePlansOffer;
    apartmentNumber?: string;
    yslabProperty?: YslabProperty | null;
    initialBuildingUuid?: string | null;
    initialFloor?: number | null;
}

export const Planner3dModal = (props: Props) => {
    const plannerData = getPlanner3dData(props.offer.id);

    const {data: investmentData} = useGetPlannerInvestmentDataQuery({investmentUuid: props.offer.uuid});

    // For YSLAB we have a hardcoded list of offers that has YSLAB planner
    if (props.vendorId && plannerData && [Planner3DTypes.YSLAB, Planner3DTypes.YSLAB_ALLINONE].includes(plannerData.type)) {
        return (
            <YslabPlanner3d
                modalId={props.routedModalId}
                offerId={props.offer.id}
                vendorId={props.vendorId}
                offerName={props.offer.name}
                yslabProperty={props.yslabProperty}
                className={props.className}
            >
                {props.children}
            </YslabPlanner3d>
        );
    }

    // For non-YSLAB offers we want to use our own floor plans from planner 2d, but first we need to check if the offer has svg plans drawn, which means:
    // - investment is_ready === true (which means that all estates in investment are marked as ready in P2D)
    // - show_floors_navigator === true (which means that this checkbox in PH is selected)
    if (investmentData?.is_ready && props.offer.configuration.show_floors_navigator) {
        return (
            <Planner3DImakeable
                offer={props.offer}
                modalId={props.routedModalId}
                initialBuildingUuid={props.initialBuildingUuid}
                initialFloor={props.initialFloor}
                className={props.className}
            >
                {props.children}
            </Planner3DImakeable>
        );
    }

    return null;
};
